export default class UniqueIdHelper {
    public static getUniqueEventId() {
        /* tslint:disable */
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random()*16|0;
            const v = c == 'x' ? r : (r&0x3|0x8);
            return v.toString(16);
        });
        /* tslint:enable */
    }
}
